import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { messageBundle, tsx } from '@arcgis/core/widgets/support/widget';
import Widget from '@arcgis/core/widgets/Widget';
import { EAppTemplateType } from 'templates-common-library/baseClasses/CompatibilityChecker';

import t9nAppMessages from "../../t9n/App/App.json";
import "./InfoBadge/InfoBadge.scss";

@subclass('Landing.widgets.InfoBadge')
export default class InfoBadge extends Widget {
  @property()
  badge: string;

  @property()
  appType: EAppTemplateType;

  @property()
  uniqueId: string;

  @property()
  overrideTooltip: string;

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof t9nAppMessages;

  constructor(props) {
    super(props);
  }

  render() {
    const uniqueId = `${this.uniqueId}`;
    const wrapperId = `infoBdg-wrapper-${uniqueId}`;
    const tooltipId = `infoBdg-tooltip-${uniqueId}`;
    const content = this._renderTooltip();
    return (
      <div key={wrapperId}>
        <calcite-tooltip 
          key={tooltipId}
          label={content}
          reference-element={uniqueId} 
          placement="top"
        >
          {content}
        </calcite-tooltip>
        <calcite-chip
          tabindex="0"
          scale="s"
          appearance="solid"
          key={uniqueId}
          id={uniqueId}
          class={this.classes("badge", `badge--${this.badge}`)}>
          {this.appMessages.appBadges[this.badge]}
        </calcite-chip>
      </div>
    )
  }

  private _renderTooltip(): string {
    if(this.overrideTooltip != null){
      return this.overrideTooltip;
    }
    const updatedTip = this.appMessages.appBadgeToolTips.Updated[this.appType];
    const genericUpdatedTip = this.appMessages.appBadgeToolTips.Updated.generic;
    return this.badge !== "Updated"
      ? this.appMessages.appBadgeToolTips[this.badge]
      : updatedTip != null ? updatedTip : genericUpdatedTip;
  }
}